import { useEffect } from 'react';
import { useApiContext } from 'react-easyrocket';
import { SIGN_UP_DATA_STORAGE_KEY } from './useCacheSignUpData';

export const useClearSignUpCache = () => {
  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    if (isAuthenticated) {
      sessionStorage.removeItem(SIGN_UP_DATA_STORAGE_KEY);
    }
  }, [isAuthenticated]);
};
